'use client'

import { useTranslate } from '@repo/shared/hooks'
import {
  Card,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { WithdrawOnlinePaymentContainer } from './withdraw'
import { CardsContainer } from './cards'
import { BalanceContainer } from './balance'

export const WalletContainer = () => {
  const { t } = useTranslate()
  const tabs = [
    {
      value: 'withdraw',
      label: t('walletPage_withdraw'),
    },
    {
      value: 'cards',
      label: t('walletPage_cards'),
    },
    {
      value: 'history',
      label: t('walletPage_history_withdraw_all'),
    },
  ]

  return (
    <div className='flex flex-col md:flex-row max-w-container-md mx-auto gap-md'>
      <Card withoutBorder className='w-full mb-9xl md:mb-0 p-md'>
        <Tabs defaultValue='withdraw' color='base' size='md' scrollable={false}>
          <TabsList className='w-full md:w-fit'>
            {tabs.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {tabs.map((tab) => (
            <TabsContent
              key={tab.value}
              value={tab.value}
              className='max-w-[720px]'
            >
              {tab.value === 'withdraw' && <WithdrawOnlinePaymentContainer />}
              {tab.value === 'cards' && <CardsContainer />}
              {tab.value === 'history' && <BalanceContainer />}
            </TabsContent>
          ))}
        </Tabs>
      </Card>
    </div>
  )
}
